import type { ZoneSummary } from '@antoja/shared';
import { useQuery } from '@tanstack/react-query';
import { t } from '../i18n';
import { surfaceClass } from '../styles';
import { Button, PageHeader, Section } from '../ui';

/** "Resumen": for now, the pilot zones. Coverage, queue and free-tier usage come in C4.4. */
export function HomeScreen({ loadPilotZones }: { loadPilotZones: () => Promise<ZoneSummary[]> }) {
  const zones = useQuery({ queryKey: ['zones', 'pilot'], queryFn: loadPilotZones });
  const note = `p-5 text-[14.5px] ${surfaceClass}`;

  return (
    <>
      <PageHeader title={t('home.title')} subtitle={t('home.subtitle')} />
      <Section title={t('zones.heading')}>
        {zones.isPending ? (
          <p role="status" className={`${note} text-muted`}>
            {t('zones.loading')}
          </p>
        ) : null}
        {zones.isError ? (
          <div role="alert" className={`grid justify-items-start gap-3 ${note}`}>
            <p>{t('zones.error')}</p>
            <Button onClick={() => void zones.refetch()}>{t('common.retry')}</Button>
          </div>
        ) : null}
        {zones.isSuccess && zones.data.length === 0 ? (
          <p className={`${note} text-muted`}>{t('zones.empty')}</p>
        ) : null}
        {zones.isSuccess && zones.data.length > 0 ? (
          <ul className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(min(220px,100%),1fr))]">
            {zones.data.map((zone) => (
              <li
                key={zone.id}
                className={`p-5 text-[22px] leading-tight font-semibold tracking-[-0.03em] ${surfaceClass}`}
              >
                {zone.name}
              </li>
            ))}
          </ul>
        ) : null}
      </Section>
    </>
  );
}
